import moment from 'moment';

export default {
	async fetchClientSettings({ commit }) {
		commit(
			'clientSettings',
			await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v1/${window.config.keyword}/settings`
			)
				.then(r => r.json())
				.catch(() => false)
		);
	},
	async fetchClientDetails({ commit }) {
		commit(
			'clientDetails',
			await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v1/${window.config.keyword}/details`
			)
				.then(r => r.json())
				.then(r => r.data)
				.catch(() => false)
		);
	},
	async fetchUserClasses({ commit }) {
		commit(
			'userClasses',
			await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v2/${window.config.keyword}/userclasses?mode=1`
			)
				.then(r => r.json())
				.catch(() => false)
		);
	},
	async fetchRoomsForLocationsOnDateForClass(
		{ commit },
		{ locations, classId, date }
	) {
		const l = locations.join(',');
		if (!l || !l.length === 0 || !date) {
			commit('currentRooms', []);
		} else {
			let url = `${process.env.VUE_APP_API_ENDPOINT}/v2/${window.config.keyword}/rooms/${l}?date=${date}`;
			if (classId) {
				url += `&class_id=${classId}`;
			}
			commit(
				'currentRooms',
				await fetch(url)
					.then(r => r.json())
					.catch(() => false)
			);
		}
	},
	async fetchOpeningHoursForDate({ commit }, date) {
		commit('openingHoursForDate', {
			openingHoursForDate: await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v1/${window.config.keyword}/opening-hours/${date}/1`
			)
				.then(r => r.json())
				.then(r => {
					const p = [];
					for (const location in r) {
						p.push({
							id: parseInt(location),
							open: moment(
								`${date} ${r[location][date]['open']}`,
								'YYYY-MM-DD h:mmA'
							).unix(),
							close: moment(
								`${date} ${r[location][date]['close']}`,
								'YYYY-MM-DD h:mmA'
							).unix()
						});
					}
					return p;
				})
				.catch(() => false),
			date
		});
	},
	async fetchRoomDetailsById({ commit }, { room, classId, date }) {
		let url = `${process.env.VUE_APP_API_ENDPOINT}/v2/${window.config.keyword}/roomdetails/${room}?`;
		if (date) {
			url += `&date=${date}`;
		}
		if (classId) {
			url += `&class_id=${classId}`;
		}

		return commit('roomDetailsById', {
			roomDetailsById: await fetch(url)
				.then(r => r.json())
				.catch(() => false),
			room,
			date,
			classId
		});
	},
	async setUserClass({ commit }, classId) {
		commit(
			'userClassLocations',
			await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v1/${window.config.keyword}/locations?only_with_external_rooms=1&class_id=${classId}`
			)
				.then(r => r.json())
				.catch(() => false)
		);
	},
	async fetchReserveLocations({ commit }) {
		commit(
			'userClassLocations',
			await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v1/${window.config.keyword}/locations?only_with_external_rooms=1`
			)
				.then(r => r.json())
				.catch(() => false)
		);
	},
	async fetchLocations({ commit }) {
		commit(
			'locations',
			await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v1/${window.config.keyword}/locations`
			)
				.then(r => r.json())
				.then(r =>
					r.map(l => {
						l.id = parseInt(l.id);
						l.lat = parseFloat(l.lat);
						l.lon = parseFloat(l.lon);
						l.app_viewable = l.app_viewable === 'true';
						return l;
					})
				)
				.catch(() => false)
		);
	},
	async fetchAssetCategory({ commit }, id) {
		commit(
			'assetCategory',
			await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v2/${window.config.keyword}/assetbooking/category/${id}`
			)
				.then(r => r.json())
				.then(r => r.data)
				.then(assetCategory => ({ assetCategory, id }))
				.catch(() => false)
		);
	},
	async fetchAssetGroup({ commit }, { id, date, assetType, multiplier }) {
		commit('isLoading', true);
		let response = await fetch(
			`${process.env.VUE_APP_API_ENDPOINT}/v2/${window.config.keyword}/assetbooking/group/${id}?date=${date}&assetType=${assetType}&multiplier=${multiplier}`
		)
			.then(r => r.json())
			.then(r => r.data)
			.then(assetGroup => ({ assetGroup, id }))
			.catch(() => false);
		commit('assetGroup', response);
		commit('isLoading', false);
	},

	async fetchAssetType({ commit }, { id, selectedDate }) {
		commit(
			'assetType',
			await fetch(
				// prettier-ignore
				`${process.env.VUE_APP_API_ENDPOINT}/v2/${window.config.keyword}/assetbooking/group/${id}?date_start=${moment(selectedDate).startOf('month').format('YYYY-MM-DD')}&date_end=${moment(selectedDate).endOf('month').format('YYYY-MM-DD')}`
			)
				.then(r => r.json())
				.then(r => r.data)
				.then(assetType => ({ assetType, id }))
				.catch(() => false)
		);
	},
	async fetchAsset({ commit }, id) {
		commit(
			'asset',
			await fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v2/${window.config.keyword}/assetbooking/asset/${id}`
			)
				.then(r => r.json())
				.then(r => r.data)
				.then(asset => ({ asset, id }))
				.catch(() => false)
		);
	},
	async fetchHTMLWidget({ commit }, id) {
		if (!id) return;
		commit(
			'HTMLWidget',
			await fetch(`${process.env.VUE_APP_API_ENDPOINT}/v1/widget/${id}`)
				.then(r => r.json())
				.then(r => ({ HTMLWidget: r.data.html, id }))
				.catch(() => false)
		);
	}
};
